module.exports = "/static/assets/304a4232e9c705070616948db02e5e07.svg";